import { event } from '../../../services/Events'

const state = {
    id: null,
    items: {},
    couponCode: '',
    currency: null,
    locale: null,
    initiated: false,
    queue: [],
}

const getters = {
    hasBeenInitiated: (state) => {
        return state.initiated;
    },

    items: (state) => {
        return Object.values(state.items).map(item => {
            return item;
        });
    },

    queue: (state) => {
        return state.queue
    },

    getPresentmentPrice: (state) => (variant) => {
        return variant.presentment_prices.find(price => {
            return state.currency === price.currency
        })
    },

    count: (state, getters) => {
        return getters.items.reduce((quantity, item) => {
            return quantity + item.quantity
        }, 0)
    },

    totalPrice: (state, getters) => {
        return getters.items.reduce((total, item) => {
            let price = getters.getPresentmentPrice(item.productVariant)

            return total + price.amountInCents * item.quantity
        }, 0)
    },

    hasVariant: (state, getters) => (variant) => {
        return !! getters.items.find(item => {
            return item.productVariant.id == variant.id
        })
    },

    hasProductInQueue: (state) => (product) => {
        return !! state.queue.find(queueProduct => queueProduct.id === product.id)
    },
}

const actions = {
    clearQueue ({ commit }) {
        commit('clearQueue')
    },

    async addVariantToCart ({ state, commit }, { productVariant, product }) {
        let productVariantIds = [productVariant.id]

        state.queue.forEach(queuedProduct => {
            let variantToAddToCart = queuedProduct.variants.find(variant => variant.slug == productVariant.slug)
            variantToAddToCart = variantToAddToCart ? variantToAddToCart : queuedProduct.variants[0]
            productVariantIds.push(variantToAddToCart.id)
        })

        await new Promise((resolve, reject) => {
            axios.post('/api/cart', {
                product_variant_ids: productVariantIds,
                cart_id: state.id,
                coupon_code: state.couponCode,
            }).then(response => {
                commit('setCartItems', response.data.items)

                event('add-to-cart', {
                    product: product,
                    productVariant: productVariant,
                    addOnProductVariants: state.queue,
                    currency: state.currency,
                })

                resolve()
            }).catch(error => {
                reject(error)
            });
        })

        commit('clearQueue')
    },

    toggleProductInQueue ({ state, commit, getters }, product) {
        if (getters.hasProductInQueue(product)) {
            commit('removeFromQueue', product)
        } else {
            commit('addToQueue', product)
        }
    },

    addProductToQueue ({ state, commit }, product) {
        commit('addToQueue', product)
    },

    removeProductFromQueue ({ state, commit }, product) {
        commit('removeFromQueue', product)
    },

    async applyCouponCode ({ state, commit }, code) {
        await new Promise((resolve, reject) => {
            axios.post('/api/cart', {
                cart_id: state.id,
                coupon_code: code,
            }).then(response => {
                resolve(commit('APPLY_COUPON_CODE', code))
            }).catch(error => {
                reject(error)
            });
        })

    },

    async initateCart ({ commit }, { id, items, currency, locale, couponCode }) {
        await commit('setCartId', id)
        await commit('setCartCurrency', currency)
        await commit('setCartLocale', locale)
        await commit('setCartItems', items)
        await commit('APPLY_COUPON_CODE', couponCode)
        await commit('setCartInitiationStatus', true)
    }
}

const mutations = {
    setCartId (state, id) {
        state.id = id
    },

    setCartItems (state, items) {
        state.items = items
    },

    setCartCurrency (state, currency) {
        state.currency = currency
    },

    setCartLocale (state, locale) {
        state.locale = locale
    },

    setCartInitiationStatus(state, status) {
        state.initiated = status
    },

    addToQueue(state, product) {
        state.queue.push(product)
    },

    removeFromQueue(state, product) {
        state.queue = state.queue.filter(queuedProduct => queuedProduct.id != product.id)
    },

    clearQueue(state) {
        state.queue = []
    },

    APPLY_COUPON_CODE(state, code) {
        state.couponCode = code
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
